// extracted by mini-css-extract-plugin
export var root = "_6OZf";
export var rootAccordion = "+SN5";
export var rootAccordionCaret = "gkHL";
export var rootAccordionContent = "VAAZ";
export var rootAccordionIcon = "Xp7h";
export var rootAccordionItem = "DxJJ";
export var rootAccordionItemActive = "d10M";
export var rootAccordionSummary = "x4BP";
export var rootAccordionSummaryActive = "YIhj";
export var rootAccordionTitle = "BQIQ";
export var rootBackground = "BoUg";
export var rootButton = "N73L";
export var rootContent = "SVSf";
export var rootHeading = "mACJ";
export var rootOverlay = "n-Kf";
export var rootPoster = "+XNd";
export var rootVideo = "DLmM";